import React, {
    useState,
    useEffect,
    useContext
}
from "react";

import {useHistory}
from 'react-router-dom';

import {functions}
from "../../../constants/common-functions";

import {JWT}
from "../../../constants/local-storage";

import {store}
from '../../../context/store';

import {FontAwesomeIcon}
from '@fortawesome/react-fontawesome';

import {CSSTransition}
from 'react-transition-group';

import './scaninfowindow.css';

import FacilityDetails
from "./FacilityDetails";

import IconNavigator
from "../../../components/IconNavigator";

import DashboardChoicePanel
from '../../../components/DashboardChoicePanel';

import OmniScanWeatherPanel
from "../../../components/local/OmniScanWeatherPanel";

import ImageViewer
from "../../../components/ImageViewer";


export default function ScanInfoWindow({

    id,

    infoBoxDisplay,

    setInfoBoxDisplay,

    onOpenForge,

    goDocuments

})
{

    //--------------------------------------------------------
    // History
    //--------------------------------------------------------

    const history =
        useHistory();


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [facility, setFacility] =
        useState({});

    const [tableRows, setTableRows] =
        useState([]);

    const [photoSource, setPhotoSource] =
        useState();

    const [arrowIcon, setArrowIcon] =
        useState("angle-right");

    const [arrowIconOpacity, setArrowIconOpacity] =
        useState("1");

    const [photoDisplay, setPhotoDisplay] =
        useState('none');

    const [imageTextDisplay, setImageTextDisplay] =
        useState('none');

    const [displayPopOutDetails, setDisplayPopOutDetails] =
        useState(false);

    const [dashboardChoiceDisplay, setDashboardChoiceDisplay] =
        useState("none");

    const [showWeather, setShowWeather] =
        useState(false);

    const [isDemo, setIsDemo] =
        useState(false);

    const [photos, setPhotos] =
        useState([]);


    //--------------------------------------------------------
    // Context
    //--------------------------------------------------------

    const globalState =
        useContext(store);


    //--------------------------------------------------------
    // Initial load
    //--------------------------------------------------------

    useEffect(

        () =>
        {

            functions.getIsDemoUser(

                (isDemo) =>
                {

                    setIsDemo(
                        isDemo
                    );

                }

            );

            loadFacility();

        },

        [id]

    );


    //--------------------------------------------------------
    // Load Forager photos
    //--------------------------------------------------------

    useEffect(

        () =>
        {

            if(!facility)
            {
                return;
            }

            loadPhotos(
                facility.code
            );

        },

        [facility]

    );


    const loadPhotos =
        (facilityCode) =>
        {

            functions.getArrayFromAjax(

                "/resolutionsoftwareplatform/folderforager/buildingphotos?buildingCode="
                    + facilityCode,

                setPhotos,

                testPhotos

            );

        };


    const testPhotos =
        (photos) =>
        {

        };


    //--------------------------------------------------------
    // Scan selection
    //--------------------------------------------------------

    const handleSelectBuilding =
        (building) =>
        {

            if(building.buildingCameraScan)
            {

                globalState.state.scanViewer.loadScan(
                    building.buildingCameraScan
                );

            }

        };


    const handleSelectFloor =
        (floor) =>
        {

            if(floor.floorCameraScan)
            {

                globalState.state.scanViewer.loadScan(
                    floor.floorCameraScan
                );

            }

        };


    //--------------------------------------------------------
    // Facility
    //--------------------------------------------------------

    const loadFacility =
        () =>
        {

            setImageTextDisplay(
                'none'
            );

            setPhotoDisplay(
                'none'
            );

            functions.getObjectFromAjax(

                "/resolutionsoftwareplatform/getfacilitypopup?facilityId="
                    + id,

                setFacility,

                buildTableRows

            );

        };


    const buildTableRows =
        (input) =>
        {

            setTableRows(
                [
                    {
                        label:
                            'Reportable Area',

                        value:
                            functions.formatNumber(
                                input.reportableArea,
                                0
                            )
                    },

                    {
                        label:
                            'Capacity',

                        value:
                            functions.formatNumber(
                                input.capacity,
                                0
                            )
                    },

                    {
                        label:
                            'Capacity per Unit Area',

                        value:
                            functions.formatNumber(
                                input.capacityPerUnitArea,
                                3
                            )
                    }
                ]
            );

            getClientInfo(
                input.code,
                input.photo
            );

        };


    //--------------------------------------------------------
    // Legacy building photo fallback
    //--------------------------------------------------------

    const getClientInfo =
        (buildingCode, photo) =>
        {

            loadPhoto(

                globalState.state.client.resourceFolderUrl
                    + "/buildingphotos/"
                    + buildingCode
                    + "/"
                    + photo

            );

        };


    const loadPhoto =
        (imageUrl) =>
        {

            fetch(

                imageUrl,

                {
                    method:
                        "GET",

                    headers:
                    {
                        'Authorization':
                            localStorage.getItem(
                                JWT
                            )
                    }
                }

            )

            .then(
                result =>
                    result.blob()
            )

            .then(
                result =>
                {

                    if(result.size > 1000)
                    {

                        setPhotoSource(

                            URL.createObjectURL(
                                result
                            )

                        );

                        setPhotoDisplay(
                            'flex'
                        );

                        setImageTextDisplay(
                            'none'
                        );

                    }
                    else
                    {

                        setImageTextDisplay(
                            'flex'
                        );

                    }

                }

            );

        };


    //--------------------------------------------------------
    // Navigation
    //--------------------------------------------------------

    const goFacility =
        () =>
        {

            history.push(
                '/facility/' + facility.id
            );

            setInfoBoxDisplay(
                "none"
            );

        };


    const goScan =
        () =>
        {

            setDisplayPopOutDetails(
                false
            );

            setArrowIconOpacity(
                "1"
            );

            setShowWeather(
                false
            );

        };


    const goDetails =
        () =>
        {

            if(functions.getIsDemoSystem() === true)
            {

                setDisplayPopOutDetails(
                    !displayPopOutDetails
                );

                setArrowIconOpacity(
                    "0"
                );

                let timer1 =
                    setTimeout(

                        () =>
                        {

                            setShowWeather(
                                true
                            );

                        },

                        2000

                    );

            }
            else
            {

                alert(
                    "This functionality for local information is coming soon"
                );

            }

        };


    const goFloors =
        () =>
        {

            history.push(
                '/facilityfloors/'
                    + facility.id
            );

        };


    const closeDetails =
        () =>
        {

            setDisplayPopOutDetails(
                false
            );

            const timer =
                setTimeout(

                    () =>
                    {

                        setArrowIconOpacity(
                            "1"
                        );

                    },

                    2000

                );


            let timer1 =
                setTimeout(

                    () =>
                    {

                        setShowWeather(
                            false
                        );

                    },

                    2000

                );

        };


    const goDashboard =
        () =>
        {

            setDashboardChoiceDisplay(
                "flex"
            );

        };


		//========================================================
		// MAIN PANEL - CINEMATIC SMOKED GLASS
		//========================================================

		const infoBox =
		{
		    display: "flex",

		    width: "450px",

		    flexDirection: "column",

		    height: "calc(100% - 60px)",

		    marginLeft: "-20px",

		    color: "#ffffff",

		    //----------------------------------------------------
		    // Architectural smoked glass
		    //----------------------------------------------------

		    background:
		        `linear-gradient(
		            145deg,
		            rgba(18, 28, 38, 0.72) 0%,
		            rgba(10, 19, 29, 0.88) 52%,
		            rgba(5, 12, 20, 0.78) 100%
		        )`,

		    backdropFilter: "blur(6px)",

		    WebkitBackdropFilter: "blur(6px)",

		    //----------------------------------------------------
		    // Glass edges
		    //----------------------------------------------------

		    border: "1px solid rgba(141, 200, 240, 0.20)",

		    borderTopLeftRadius: "0px",

		    borderBottomLeftRadius: "0px",

		    borderBottom: "2px solid rgba(69, 175, 224, 0.70)",

		    //----------------------------------------------------
		    // Depth
		    //----------------------------------------------------

		    boxShadow:
		        `
		        -8px 0 28px rgba(0,0,0,0.28),
		        inset 0 1px 0 rgba(255,255,255,0.08)
		        `,

		    //overflow: "hidden"
		};

    //========================================================
    // HEADER
    //========================================================

    const infoBoxHeader =
    {
        display:
            "flex",

        width:
            "100%",

        justifyContent:
            "space-between"
    };


    const infoBoxTitle =
    {
        display:
            "flex",

        height:
            "60px",

        fontSize:
            "20px",

        fontWeight:
            600,

        color:
            "#ffffff",

        letterSpacing:
            "0.4px",

        alignItems:
            "center",

        justifyContent:
            "center",

        width:
            "calc(100% - 40px)",

        marginLeft:
            "20px",

        marginRight:
            "20px",

        borderBottom:
            "1px solid rgba(255,255,255,0.10)"
    };


    //========================================================
    // BUILDING PHOTO
    //========================================================

	const buildingPhotoContainer =
	{
	    display: "flex",

	    marginLeft: "20px",
	    marginRight: "20px",
	    marginTop: "14px",

	    width: "calc(100% - 40px)",

	    alignItems: "center",
	    justifyContent: "center",

	    background: "rgba(3, 9, 16, 0.42)",

	    border: "1px solid rgba(141, 200, 240, 0.18)",

	    boxShadow:
	        `
	        0 8px 24px rgba(0,0,0,0.20),
	        inset 0 1px 0 rgba(255,255,255,0.06)
	        `,

	    borderRadius: "8px",

	    minHeight: "200px",

	    overflow: "hidden",

	    boxSizing: "border-box"
	};


    const buildingPhoto =
    {
        width:
            "100%",

        height:
            "100%",

        objectFit:
            "cover"
    };


    const imageText =
    {
        color:
            "rgba(255,255,255,0.58)",

        fontSize:
            "13px"
    };


    //========================================================
    // DESCRIPTION
    //========================================================

    const buildingDescription =
    {
        display:
            "flex",

        marginLeft:
            "20px",

        marginRight:
            "20px",

        width:
            "calc(100% - 40px)",

        color:
            "rgba(255,255,255,0.70)",

        fontSize:
            "12px",

        lineHeight:
            "18px",

        minHeight:
            "40px",

        alignItems:
            "center",

        borderBottom:
            "1px solid rgba(255,255,255,0.08)"
    };


    //========================================================
    // TABLE
    //========================================================

    const tableBorderColor =
        "rgba(255,255,255,0.09)";


    const tableContainer =
    {
        display:
            "flex",

			background: "rgba(3, 9, 16, 0.48)",

			border: "1px solid rgba(141, 200, 240, 0.14)",

			borderRadius: "8px",

        color:
            "#ffffff",

        margin:
            "20px",

        width:
            "calc(100% - 40px)",

        flexDirection:
            "column",

        boxSizing:
            "border-box"
    };


    const tableRow =
    {
        display:
            "flex",

        width:
            "100%",

        height:
            "40px",

        borderBottom:
            "1px solid "
            + tableBorderColor
    };


    const tableColumn =
    {
        display:
            "flex",

        height:
            "100%",

        alignItems:
            "center",

        paddingLeft:
            "12px",

        fontSize:
            "12px",

        color:
            "rgba(255,255,255,0.68)",

        width:
            "calc(50% - 12px)",

        borderRight:
            "1px solid "
            + tableBorderColor
    };


    const tableColumnValue =
    {
        display:
            "flex",

        flexDirection:
            "row-reverse",

        height:
            "100%",

        alignItems:
            "center",

        paddingRight:
            "12px",

        fontSize:
            "12px",

        fontWeight:
            600,

        color:
            "#ffffff",

        width:
            "calc(50% - 12px)"
    };


    const tableRowDisplay =
        tableRows.map(

            (item, index) =>
            {

                return (

                    <div

                        key={index}

                        style={{
                            ...tableRow,

                            borderBottom:
                                index ===
                                tableRows.length - 1

                                    ?

                                    "none"

                                    :

                                    tableRow.borderBottom
                        }}

                    >

                        <div style={tableColumn}>

                            {item.label}

                        </div>

                        <div style={tableColumnValue}>

                            {item.value}

                        </div>

                    </div>

                );

            }

        );


    //========================================================
    // SIDE ARROW
    //========================================================

    const handleArrowClick =
        () =>
        {

            if(infoBoxDisplay === true)
            {

                setArrowIcon(
                    "arrow-left"
                );

            }
            else
            {

                setArrowIcon(
                    "arrow-right"
                );

            }

            setInfoBoxDisplay(
                !infoBoxDisplay
            );

        };


    const iconStyle =
    {
        display:
            "flex",

        width:
            "18px",

        height:
            "18px",

        color:
            "#ffffff",

        cursor:
            "pointer"
    };


    const thisContainer =
    {
        display:
            "flex",

        alignItems:
            "center",

        height:
            "100%"
    };


    const arrowHolder =
    {
        display:
            "flex",

        width:
            "40px",

        height:
            "40px",

        //----------------------------------------------------
        // Action = light blue
        //----------------------------------------------------

        background:
            "linear-gradient(180deg, #45afe0 0%, #2695cc 100%)",

        alignItems:
            "center",

        justifyContent:
            "center",

        borderRadius:
            "50%",

        border:
            "1px solid rgba(255,255,255,0.20)",

        boxShadow:
            "0 5px 16px rgba(0,0,0,0.24)",

        zIndex:
            "1000",

        opacity:
            arrowIconOpacity
    };


    //========================================================
    // ICON NAVIGATOR
    //========================================================

    const iconNavigatorPanel =
    {
        display:
            "flex",

        width:
            "calc(100% - 40px)",

        marginLeft:
            "20px",

        marginRight:
            "20px",

        paddingTop:
            "16px",

        paddingBottom:
            "4px"
    };


    const iconNavigators =
    [
        {
            id:
                "1",

            label:
                "Scan",

            icon:
                "camera",

            clickFunction:
                goScan
        },

        {
            id:
                "2",

            label:
                "Details",

            icon:
                "info",

            clickFunction:
                goDetails
        },

        {
            id:
                "3",

            label:
                "Resources",

            icon:
                "book",

            clickFunction:
                goDocuments
        },

        {
            id:
                "4",

            label:
                "Floors",

            icon:
                "list-ul",

            clickFunction:
                goFloors
        },

        {
            id:
                "5",

            label:
                "Dashboards",

            icon:
                "chart-pie",

            clickFunction:
                goDashboard
        }
    ];


    const iconNavigatorDisplay =
        iconNavigators.map(

            (item) =>

                <IconNavigator

                    key={item.id}

                    id={item.id}

                    icon={item.icon}

                    label={item.label}

                    clickFunction={item.clickFunction}

                />

        );


    //========================================================
    // RENDER
    //========================================================

    return (

        <CSSTransition

            in={infoBoxDisplay}

            classNames="scaninfowindow"

            timeout={1000}

            appear={false}

        >

            <div className="scaninfowindow">

                <div style={thisContainer}>


                    {/* ======================================
                        OPEN / CLOSE
                    ======================================= */}

                    <div style={arrowHolder}>

                        <FontAwesomeIcon

                            icon={arrowIcon}

                            style={iconStyle}

                            onClick={handleArrowClick}

                        />

                    </div>


                    {/* ======================================
                        INFO PANEL
                    ======================================= */}

                    <div style={infoBox}>


                        {/* ----------------------------------
                            TITLE
                        ----------------------------------- */}

                        <div style={infoBoxHeader}>

                            <div style={infoBoxTitle}>

                                {facility.name}

                            </div>

                        </div>


                        {/* ----------------------------------
                            BUILDING PHOTO
                        ----------------------------------- */}

                        <div style={buildingPhotoContainer}>

                            {
                                photos
                                &&
                                photos.length > 0

                                ?

                                <ImageViewer
                                    photos={photos}
                                />

                                :

                                <>

                                    <img

                                        src={photoSource}

                                        alt=""

                                        style={{
                                            ...buildingPhoto,

                                            display:
                                                photoDisplay
                                        }}

                                    />

                                    <div

                                        style={{
                                            ...imageText,

                                            display:
                                                imageTextDisplay
                                        }}

                                    >

                                        No image available

                                    </div>

                                </>

                            }

                        </div>


                        {/* ----------------------------------
                            DESCRIPTION
                        ----------------------------------- */}

                        <div style={buildingDescription}>

                            {facility.description}

                        </div>


                        {/* ----------------------------------
                            WEATHER
                        ----------------------------------- */}

                        {
                            showWeather
                            &&
                            <OmniScanWeatherPanel

                                building={{
                                    name:
                                        facility.name,

                                    location:
                                        facility.address
                                        ||
                                        facility.name
                                }}

                            />
                        }


                        {/* ----------------------------------
                            NAVIGATION / DATA
                        ----------------------------------- */}

                        {
                            !showWeather
                            &&
                            <>

                                <div style={iconNavigatorPanel}>

                                    {iconNavigatorDisplay}

                                </div>

                                <div style={tableContainer}>

                                    {tableRowDisplay}

                                </div>

                            </>
                        }

                    </div>

                </div>


                {/* ==========================================
                    DETAILS
                =========================================== */}

                <FacilityDetails

                    displayFlag={displayPopOutDetails}

                    closeFunction={closeDetails}

                />


                {/* ==========================================
                    DASHBOARDS
                =========================================== */}

                <DashboardChoicePanel

                    display={dashboardChoiceDisplay}

                    facilityId={id}

                    setDisplay={setDashboardChoiceDisplay}

                />

            </div>

        </CSSTransition>

    );

}